import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  
  timestamps = new Date();
  time = this.timestamps.toUTCString().split(" ")[4]; 

}
